import React, { useEffect, useState } from 'react'
import { Card, Col, InputNumber, Row, Space, Typography } from 'antd'
import { RULES, serverSentence } from './labels'
import {
  getRequest,
  patchRequest,
  successNotification,
  dutyAssistantConfigUrl
} from '../../../config'

const { Text, Paragraph } = Typography

// When the follow-ups go out, and to whom (spec: duty-follow-up-messages, w-admin Req 2). Each
// field saves on its own, so a mistake in one never holds up another.
const RulesPanel = () => {
  const [loading, setLoading] = useState(false)
  const [config, setConfig] = useState(null)
  const [values, setValues] = useState({})
  const [saving, setSaving] = useState({})
  const [errors, setErrors] = useState({})

  const load = async () => {
    const response = await getRequest(dutyAssistantConfigUrl, 'settings', setLoading)
    if (response.success) {
      setConfig(response.data)
      setValues(response.data)
    }
  }

  useEffect(() => {
    load()
    // eslint-disable-next-line
  }, [])

  const save = async rule => {
    const value = values[rule.field]
    if (value === config[rule.field] || value === null || value === undefined) return
    setErrors(e => ({ ...e, [rule.field]: '' }))
    const response = await patchRequest(
      dutyAssistantConfigUrl,
      { [rule.field]: value },
      'setting',
      flag => setSaving(s => ({ ...s, [rule.field]: flag }))
    )
    if (!response.success) {
      setErrors(e => ({ ...e, [rule.field]: serverSentence(response) }))
      setValues(v => ({ ...v, [rule.field]: config[rule.field] }))
      return
    }
    setConfig(response.data)
    setValues(response.data)
    successNotification(`${rule.label} saved`)
  }

  if (!config) return <Card loading={loading} />

  return (
    <Card>
      <Paragraph type="secondary">
        Changes apply to messages scheduled from now on.
      </Paragraph>
      {RULES.map(rule => (
        <Row key={rule.field} gutter={16} style={{ marginBottom: 20 }} align="top">
          <Col xs={24} md={8}>
            <Text strong>{rule.label}</Text>
          </Col>
          <Col xs={24} md={16}>
            <Space>
              <InputNumber
                min={rule.min}
                max={rule.max}
                precision={0}
                value={values[rule.field]}
                disabled={saving[rule.field]}
                onChange={value => setValues(v => ({ ...v, [rule.field]: value }))}
                onBlur={() => save(rule)}
                onPressEnter={() => save(rule)}
              />
              <Text>{rule.unit}</Text>
              <Text type="secondary" style={{ fontSize: 12 }}>
                ({rule.min}–{rule.max})
              </Text>
            </Space>
            <div>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {rule.help}
              </Text>
            </div>
            {errors[rule.field] && (
              <div>
                <Text type="danger">{errors[rule.field]}</Text>
              </div>
            )}
          </Col>
        </Row>
      ))}
    </Card>
  )
}

export default RulesPanel
